<rs-modal #modal
  (show)="show($event)"
  [config]="modalConfig"
  (submit)="send()">

  <div class="container p-3">
    @if (!config && !mainForm) {
      <div
        class="w-100 position-relative">
        <rs-spinner [loading]="true"
          wrapClass="spinner-border-lg spinner-center">
        </rs-spinner>
      </div>
    }
    @if (config && mainForm) {
      <div>
        @if (!readyForPreview) {
          <form
            [formGroup]="form"
            (ngSubmit)="send()">
            <div class="flex-grow-1">
              <div class="container">
                @for (group of config.form.cards[0].groups; track group; let i = $index; let lastGroup = $last) {
                  <div>
                    @if (group.title) {
                      <h3
                      class="fs-20 pb-2 fw-700">{{ group.title | translate }}</h3>
                    }
                    <rs-ui [config]="mainForm[0]"
                    #resolver></rs-ui>
                    @if (!lastGroup) {
                      <hr />
                    }
                  </div>
                }
              </div>
            </div>
          </form>
        } @else {
          @if (!readyForClosingMessage) {
            <div>
              @if (!submissionInProgress) {
                <dl>
                  <dt>{{ config.form.cards[1].groups[0].title | translate }}</dt>
                  <dd>{{orgSubmissionPayload?.formFields?.healthInsurance || 'N/A' }}</dd>
                  <dt>{{ config.form.cards[1].groups[1].title | translate }}</dt>
                  <dd>{{orgSubmissionPayload?.formFields?.memberLastName }}</dd>
                  <dt>{{ config.form.cards[1].groups[2].title | translate }}</dt>
                  <dd>{{orgSubmissionPayload?.formFields?.memberFirstName }}</dd>
                  <dt>{{ config.form.cards[1].groups[3].title | translate }}</dt>
                  <dd>{{orgSubmissionPayload?.formFields?.preferredContactMethod }}</dd>
                  <dt>{{ config.form.cards[1].groups[4].title | translate }}</dt>
                  <dd>{{orgSubmissionPayload?.formFields?.emailAddress || 'N/A' }}</dd>
                  <dt>{{ config.form.cards[1].groups[5].title | translate }}</dt>
                  <dd>{{orgSubmissionPayload?.formFields?.phoneNumber || 'N/A' }}</dd>
                  @if (orgSubmissionPayload?.formFields?.currentProcedures?.length) {
                    <div>
                      <dt>{{ config.form.cards[1].groups[6].title | translate }}</dt>
                      @for (procedure of orgSubmissionPayload?.formFields?.currentProcedures; track procedure) {
                        <dd>{{procedure}}</dd>
                      }
                    </div>
                  }
                  <dt>{{ config.form.cards[1].groups[7].title | translate }}</dt>
                  <dd>{{orgSubmissionPayload?.formFields?.locationName }}</dd>
                  @if (orgSubmissionPayload?.formFields?.additionalComments) {
                    <div>
                      <dt>{{ config.form.cards[1].groups[8].title | translate }}</dt>
                      <dd>{{orgSubmissionPayload?.formFields?.additionalComments}}</dd>
                    </div>
                  }
                </dl>
              } @else {
                <div class="container overflow-hidden p-2 mb-2">
                  <rs-spinner [loading]="true"
                    wrapClass="spinner-border-lg spinner-center">
                  </rs-spinner>
                </div>
              }
            </div>
          } @else {
            <div>
              {{ config.form.cards[2].groups[0].title | translate}}
            </div>
          }
        }
      </div>
    }
  </div>
</rs-modal>